var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonNoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Network/Carbon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.8834C0.673697 21.8882 0.847994 21.8907 1.02286 21.8907C4.61893 21.8907 7.97388 20.8583 10.8075 19.0739C11.9675 25.0445 17.2246 29.5519 23.5344 29.5519C28.6985 29.5519 33.1574 26.5327 35.2423 22.1632C35.4039 22.0778 35.5635 21.989 35.721 21.8971C33.4425 29.4629 26.4211 34.9737 18.1126 34.9737C9.79905 34.9737 2.7742 29.4562 0.5 21.8834Z",
    fill: "url(#paint0_radial_1855_15250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.8834C0.673697 21.8882 0.847994 21.8907 1.02286 21.8907C4.61893 21.8907 7.97388 20.8583 10.8075 19.0739C11.9675 25.0445 17.2246 29.5519 23.5344 29.5519C28.6985 29.5519 33.1574 26.5327 35.2423 22.1632C35.4039 22.0778 35.5635 21.989 35.721 21.8971C33.4425 29.4629 26.4211 34.9737 18.1126 34.9737C9.79905 34.9737 2.7742 29.4562 0.5 21.8834Z",
    fill: "#04171E",
    fillOpacity: 0.88
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.587891 22.1685C0.732377 22.1719 0.877269 22.1736 1.02256 22.1736C4.64033 22.1736 8.01408 21.1287 10.8585 19.3243C12.115 25.1701 17.3128 29.5519 23.5341 29.5519C28.6982 29.5519 33.1571 26.5327 35.242 22.1632C35.4036 22.0778 35.5632 21.989 35.7207 21.897C33.4422 29.4629 26.4208 34.9736 18.1123 34.9736C9.90347 34.9736 2.95107 29.5943 0.587891 22.1685Z",
    fill: "url(#paint1_radial_1855_15250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.587891 22.1685C0.732377 22.1719 0.877269 22.1736 1.02256 22.1736C4.64033 22.1736 8.01408 21.1287 10.8585 19.3243C12.115 25.1701 17.3128 29.5519 23.5341 29.5519C28.6982 29.5519 33.1571 26.5327 35.242 22.1632C35.4036 22.0778 35.5632 21.989 35.7207 21.897C33.4422 29.4629 26.4208 34.9736 18.1123 34.9736C9.90347 34.9736 2.95107 29.5943 0.587891 22.1685Z",
    fill: "#04171E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8116 29.1341C24.1973 31.3085 20.8366 32.6161 17.1705 32.6161C10.3271 32.6161 4.54791 28.0597 2.70117 21.8151C5.66172 21.5472 8.41976 20.5776 10.8076 19.0739C11.9676 25.0445 17.2246 29.5519 23.5344 29.5519C24.6666 29.5519 25.7648 29.4068 26.8116 29.1341Z",
    fill: "url(#paint2_linear_1855_15250)",
    fillOpacity: 0.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2008 16.5867C33.2008 24.9189 26.4462 31.6734 18.114 31.6734C9.78189 31.6734 3.02734 24.9189 3.02734 16.5867C3.02734 8.25455 9.78189 1.5 18.114 1.5C26.4462 1.5 33.2008 8.25455 33.2008 16.5867Z",
    fill: "url(#paint3_radial_1855_15250)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.1961 13.7538C32.1961 19.6123 27.4469 24.3616 21.5883 24.3616C15.7298 24.3616 10.9805 19.6123 10.9805 13.7538C10.9805 7.89523 15.7298 3.14594 21.5883 3.14594C27.4469 3.14594 32.1961 7.89523 32.1961 13.7538Z",
    fill: "url(#paint4_radial_1855_15250)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1029 3.165C18.8663 3.15234 18.628 3.14594 18.3882 3.14594C16.1313 3.14594 14.007 3.7138 12.1504 4.71443C13.1433 4.49564 14.1751 4.3803 15.2337 4.3803C16.3128 4.3803 17.3639 4.50013 18.3744 4.7272L19.1029 3.165Z",
    fill: "url(#paint5_linear_1855_15250)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9758 5.18751C25.5224 7.14207 29.4975 12.4289 29.4975 18.6441C29.4975 21.1993 28.8256 23.5976 27.6489 25.6719C30.0607 23.2855 31.5548 19.9735 31.5548 16.3125C31.5548 9.87268 26.9315 4.51267 20.823 3.37061L19.9758 5.18751Z",
    fill: "url(#paint6_linear_1855_15250)",
    fillOpacity: 0.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1748 29.341C23.8426 30.8184 21.0774 31.6737 18.1123 31.6737C13.4134 31.6737 9.21613 29.5254 6.44922 26.1575C7.21198 26.2972 7.99807 26.3703 8.80121 26.3703C14.633 26.3703 19.5654 22.52 21.1952 17.2228C21.7329 17.2701 22.2772 17.2942 22.8272 17.2942C26.5949 17.2942 30.0979 16.161 33.0139 14.2168C33.1358 14.989 33.1991 15.7806 33.1991 16.587C33.1991 17.0876 33.1747 17.5824 33.127 18.0705C32.2796 22.6474 29.7369 26.6294 26.1748 29.341Z",
    fill: "url(#paint7_linear_1855_15250)",
    fillOpacity: 0.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.503906 21.8969C2.78225 29.4631 9.80381 34.9742 18.1126 34.9742C28.2283 34.9742 36.436 26.8054 36.4991 16.7045C35.49 16.6982 34.5001 16.6105 33.5357 16.4478C31.2694 17.4466 28.7632 18.0012 26.1275 18.0012C25.2135 18.0012 24.3151 17.9345 23.4369 17.8057C21.809 23.106 16.875 26.9591 11.0411 26.9591C6.97296 26.9591 3.34243 25.0855 0.965392 22.154C0.809651 22.0714 0.655795 21.9856 0.503906 21.8969Z",
    fill: "url(#paint8_linear_1855_15250)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5008 16.7205C33.7964 18.2848 30.6566 19.1801 27.3078 19.1801C26.6695 19.1801 26.0389 19.1476 25.4174 19.0841C24.2535 25.0498 18.9988 29.5522 12.6925 29.5522C7.52844 29.5522 3.06951 26.533 0.984594 22.1635C0.822962 22.0781 0.663353 21.9894 0.505859 21.8974C2.7844 29.4632 9.80581 34.974 18.1143 34.974C28.2246 34.974 36.429 26.8139 36.5008 16.7205Z",
    fill: "url(#paint9_radial_1855_15250)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1599 17.4238C34.0524 17.9477 32.8841 18.3642 31.6686 18.6598C31.511 20.0025 31.208 21.349 30.7498 22.6795C29.6331 25.9227 27.7322 28.6731 25.332 30.7916C29.4361 28.8167 32.78 25.2659 34.38 20.6193C34.7443 19.5611 35.0024 18.4921 35.1599 17.4238Z",
    fill: "url(#paint10_linear_1855_15250)",
    fillOpacity: 0.64
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4308 17.8373C23.4515 17.8095 23.4903 17.8043 23.5173 17.8257C24.131 18.3126 24.7943 18.742 25.5053 19.1064C25.5358 19.122 25.5482 19.1602 25.5331 19.1916C25.5179 19.223 25.4809 19.2358 25.4504 19.2202C24.7322 18.8522 24.0621 18.4183 23.442 17.9264C23.415 17.905 23.41 17.8651 23.4308 17.8373Z",
    fill: "url(#paint11_linear_1855_15250)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1855_15250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.721 31.0899) rotate(179.948) scale(133.505 387.914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1855_15250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7207 31.09) rotate(179.948) scale(133.505 387.914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1855_15250",
    x1: 26.3607,
    y1: 35.1578,
    x2: 20.295,
    y2: 3.60683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1855_15250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.0733 28.3818) rotate(-57.5402) scale(26.5764 385.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1855_15250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1383 3.15008) rotate(144.267) scale(26.1358 25.9503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906332,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1855_15250",
    x1: 27.6608,
    y1: 9.04332,
    x2: 12.1027,
    y2: 15.8206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1855_15250",
    x1: 27.6608,
    y1: 9.04332,
    x2: 12.1027,
    y2: 15.8206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1855_15250",
    x1: 56.538,
    y1: -23.1937,
    x2: -7.09375,
    y2: 29.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1855_15250",
    x1: 29.781,
    y1: 19.003,
    x2: 5.91326,
    y2: 27.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1855_15250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.33242 32.9827) rotate(-38.5632) scale(21.7615 339.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1855_15250",
    x1: 35.2043,
    y1: 17.4119,
    x2: 26.0255,
    y2: 31.3248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1855_15250",
    x1: 25.5272,
    y1: 19.1599,
    x2: 22.5432,
    y2: 17.3153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNoBg);
export default __webpack_public_path__ + "static/media/carbon_no_bg.90499669.svg";
export { ForwardRef as ReactComponent };